module.exports = __webpack_public_path__ + "img/pps.bad4cc5b.png";